import request from '@/utils/request'
let preBase = 'mixApi'

// 厦门国际银行-企业微信拉新抽奖活动-登录
export const login = (data) => {
  return request({
    url: `${preBase}/xibWorkWeChatLottery/login`,
    method: 'post',
    data,
    custom: true,
    hideLoading: true,
  })
}
// 厦门国际银行-企业微信拉新抽奖活动- 查询能否抽奖
export const getLotteryStauts = (data) => {
  return request({
    url: `${preBase}/xibWorkWeChatLottery/getLotteryStauts`,
    method: 'post',
    token: sessionStorage.getItem('xibWorkWeChatLotteryToken'),
    data,
    hideLoading: true,
  })
}
// 厦门国际银行-企业微信拉新抽奖活动-达标查询
export const check = (data) => {
  return request({
    url: `${preBase}/xibWorkWeChatLottery/check`,
    method: 'post',
    token: sessionStorage.getItem('xibWorkWeChatLotteryToken'),
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 厦门国际银行-企业微信拉新抽奖活动- 抽奖
export const lottery = (data) => {
  return request({
    url: `${preBase}/xibWorkWeChatLottery/lottery`,
    method: 'post',
    token: sessionStorage.getItem('xibWorkWeChatLotteryToken'),
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}


// 厦门国际银行-企业微信拉新抽奖活动-领取记录分页
export const getRecordPages = (data) => {
  return request({
    url: `${preBase}/xibWorkWeChatLottery/myPrize`,
    method: 'post',
    token: sessionStorage.getItem('xibWorkWeChatLotteryToken'),
    data,
    hideLoading: true,
  })
}
